import { configureStore } from '@reduxjs/toolkit';
import surveyStatsReducer from './slices/surveyStatsSlice'; 

const store = configureStore({
  reducer: {
    surveyStats: surveyStatsReducer,
  },
});

export default store;
